import BalloonPanelView from '@ckeditor/ckeditor5-ui/src/panel/balloon/balloonpanelview';
import BlockToolbar from '@ckeditor/ckeditor5-ui/src/toolbar/block/blocktoolbar';

export default class VjBlockToolbar extends BlockToolbar {

    _createPanelView() {
        const panelView = super._createPanelView()
        debugger
        const defaultPositions = BalloonPanelView.defaultPositions;
        const southArrowNorthWestOnly = {
            positions: [
                defaultPositions.southArrowNorthWest
            ]
        }
        const pinDelegate = panelView.pin
        panelView.pin = ( options ) => {
            const newOptions = Object.assign( {}, options, southArrowNorthWestOnly )
            pinDelegate.bind( panelView )( newOptions )
        }
        return panelView;
    }
};
